import { render } from "./subscriptionplan.vue?vue&type=template&id=0dcd3242&scoped=true"
import script from "./subscriptionplan.vue?vue&type=script&lang=js"
export * from "./subscriptionplan.vue?vue&type=script&lang=js"

import "./subscriptionplan.vue?vue&type=style&index=0&id=0dcd3242&scoped=true&lang=css"
import "./subscriptionplan.vue?vue&type=style&index=1&id=0dcd3242&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dcd3242"]])

export default __exports__